var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseShippingMethodListItem',_vm._b({on:{"click":_vm.createShipping}},'BaseShippingMethodListItem',{ method: _vm.method },false))}
var staticRenderFns = []

export { render, staticRenderFns }